module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAAAAAAfl4auAAABMElEQVRIx+3XzUrDQBSG4bnzM1YKwUJdaCQQEKTQgqCLBpUW6kaCFxBwk8WAhaJYf3ElkrHJaYMoTJLvIEjpuyhpyUPDlKFnlM3L0sj3qGaeH6VZwVT+YgJqWGBWONbUOB0zjgkqzrHRGNbGqiwgsCBTKcGlKsJxpHwc+8rDsadI0PrggxNuB8D6odhu9rkF4FO2dgg89tYj28/xxe86FXhoHYVu3HoR4DOL4+03vusuXDThaxOWtZ14tPyKfv7mmK9vaq52+53vnxKAlw9qjxC8u88RghddJmW3jF/LDwZV2Dh+qcm/x11owTa4CR7N5x/ODX3owFe2oj/D57PvPf3cGEmyV/vvpvlqbzCOe/dF12s3k4iGONH4KBpcRSOzaFgXHRNkBxTZ0Uh2KIOPg1+xezzGtG1GhgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/device/gray_year_icon.png
// module id = UED8
// module chunks = 1